<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="wrapperBox">
        <v-row
          no-gutters
          justify="center"
          v-if="canCreatePost"
          class="createPostBtnWrapper"
        >
          <v-btn
            depressed
            :x-large="$vuetify.breakpoint.mdAndDown ? false : true"
            color="primary"
            class="createBtn text-none font-weight-bold text-md-h6 subtitle-1"
            @click="isOpenDialog()"
          >
            <translate>Create post</translate>
          </v-btn>
        </v-row>
        <!-- content post -->
        <div v-if="posts.length === 0 && typeShowText.name">
          <span class="mr-1 font-weight-bold">{{typeShowText.name}}</span>{{showTextNoPost()}}
        </div>
        <template v-else>
          <Post
            ref="Post"
            v-for="(item, key) in posts"
            :item="item"
            :key="key"
            @onData="onData"
          />
        </template>

        <InfiniteLoad @loading="onLoadPost" :disabled="endData" />
      </div>
    </v-col>
    <ModifyPost
      ref="dialogModifyPost"
      @postCreated="handlePostCreated"
      @postUpdated="handlePostUpdated"
      :isGolfCourse="isGolfCourse"
      :postType="postType"
      :courseId="courseId"
    />
  </v-row>
</template>
<script>
import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";
import ModifyPost from "@/components/Post/ModifyPost.vue";
import Post from "@/components/Post/Post.vue"; // post card
export default {
  name: "PostList",
  props: {
    action: { type: String, default: "" },
    postType: { type: Number },
    courseId: { type: Number },
    userPost: {},
    canCreatePost: { type: Boolean, default: false },
    isGolfCourse: { type: Boolean, default: false },
    language: {},
    typeShowText: {
      type: Object,
      default: function() {
      return { name: '', type: null }
    }}
  },
  components: {
    ModifyPost,
    Post,
    InfiniteLoad,
  },
  data() {
    return {
      posts: [],
      endData: false,
      currentPage: 1,
      totalPages: 1,
    };
  },
  methods: {
    showTextNoPost() {
      const text = this.$gettextInterpolate(
        this.$gettext("has not updated any %{type} yet. However, following %{name} you will be received notifications for new %{type}"),
        {name: this.typeShowText.type == 'user' ? this.typeShowText.name : this.$gettext('this page'),
        type: this.typeShowText.vlog || this.$gettext('posts')
        }
      )
      return text
    },
    // create , update, delete
    onData(item) {
      let i = this.posts.findIndex((x) => x.id == item.id);
      if (item.mode === "create") {
        delete item.mode;
        this.posts.splice(0, 0, item); //unshift
      } else if (item.mode === "update") {
        delete item.mode;
        const updated = { ...this.posts[i], ...item };
        this.$set(this.posts, i, updated);
      } else {
        this.posts.splice(i, 1);
        this.refreshComment();
      }
      return;
    },
    isOpenDialog() {
      this.$refs.dialogModifyPost.isOpenDialog = true;
    },
    refreshComment() {
      const Post = this.$refs.Post;
      if (Post) {
        for (let p of Post) {
          p.refreshComment();
        }
      }
    },
    handlePostCreated(post) {
      this.posts.splice(0, 0, post); //unshift
      this.refreshComment();
    },
    handlePostUpdated(post) {
      let i = this.posts.findIndex((x) => x.id == post.id);
      this.$set(this.posts, i, { ...this.posts[i], ...post });
    },
    async onLoadPost(page) {
      if (this.action) {
        let limit = 10;
        let user = this.userPost;
        let result = await this.$store.dispatch(this.action, {
          page,
          limit,
          user,
        });
        if (!result.error) {
          if (result.list && result.list.length) {
            this.posts = this.posts.concat(result.list);
          }
          if (this.language == "all") {
            this.$root.$emit("getTotal", result.total);
          }
          //stop load
          if (
            result.totalPages == 0 ||
            result.totalPages == 1 ||
            !result.list.length
          ) {
            this.endData = true;
          }
        }
      }
    },
  },
};
</script>

